module.exports = __webpack_public_path__ + "img/company-introduction-bg.8e89f75e.png";